import * as React from 'react'

import TextInput from 'airship/patterns/TextInput'

interface Props {
  name: string
  value: string | undefined
  onChange: (arg: string) => void
  helperLink?: string
  optionalLabel?: boolean
}

const AdditionalTextInput: React.FC<Props> = ({
  name,
  value,
  onChange,
  helperLink,
  optionalLabel,
}) => {
  return (
    <>
      <div className="u-flex">
        <p className="u-text-bold u-text-grow-2 u-space-bottom-05">{name}</p>
        {optionalLabel && <p className="u-space-left-05">(Optional)</p>}
        {helperLink && (
          <a
            href={helperLink}
            target="_blank"
            rel="noopener noreferrer"
            className="u-space-left-1"
          >
            What is this?
          </a>
        )}
      </div>
      <TextInput
        displayClasses="u-space-bottom-05"
        value={value}
        onChange={onChange}
      />
    </>
  )
}

export default AdditionalTextInput
